module.exports = __webpack_public_path__ + "img/Comic05-4.7e85b742.png";